export default __webpack_public_path__ + "static/media/Emblem_Silver.7726f056.webp";